import type { ChatSummary } from '../api/types';

export type ChatMuteMode = 'off' | 'hour' | 'eight_hours' | 'twenty_hours' | 'day' | 'three_days' | 'seven_days' | 'thirty_days' | 'forever' | 'custom';

export function isChatMutedAt(chat: Pick<ChatSummary, 'muted' | 'mutedUntil'> | null | undefined, nowMs = Date.now()): boolean {
  if (chat?.muted) return true;
  const mutedUntil = chat?.mutedUntil;
  if (typeof mutedUntil !== 'string') return false;
  const untilMs = Date.parse(mutedUntil);
  return Number.isFinite(untilMs) && untilMs > nowMs;
}
